import Auction, { AuctionType } from '../interfaces/Auction';
import { Bid } from '../interfaces/Bid';
import { OpeningHour } from '../interfaces/OpeningHours';

export const openBiddingView = (
  auctionId: string,
  buyMethod: AuctionType,
  flow?: string
) => ({
  type: 'OPEN_BIDDING_VIEW' as const,
  payload: auctionId,
  flow: flow,
  buyMethod: buyMethod
});

export const closeBiddingView = () => ({
  type: 'CLOSE_BIDDING_VIEW' as const
});

export const updateMyBidderAlias = ({
  auctionId,
  myBidderAlias
}: {
  auctionId: string;
  myBidderAlias: string;
}) => ({
  type: 'UPDATE_MY_BIDDER_ALIAS' as const,
  payload: {
    auctionId,
    myBidderAlias
  }
});

export const updateMyBidderAliases = (auctions: Auction[]) => ({
  type: 'UPDATE_MY_BIDDER_ALIASES' as const,
  auctions: auctions
});

export const biddingViewSetAllBids = (payload: Bid[]) => ({
  type: 'BIDDING_VIEW_SET_ALL_BIDS' as const,
  payload
});

export const setCustomerSupportSchedule = (payload: OpeningHour[]) => ({
  type: 'BIDDING_VIEW_SET_SUPPORT_SCHEDULE' as const,
  payload
});

export type UpdateAliasAction =
  | ReturnType<typeof updateMyBidderAliases>
  | ReturnType<typeof updateMyBidderAlias>;

export type BiddingViewAction =
  | ReturnType<typeof openBiddingView>
  | ReturnType<typeof closeBiddingView>
  | ReturnType<typeof setCustomerSupportSchedule>
  | ReturnType<typeof biddingViewSetAllBids>;
